import { ADRESS_STATUS_OPTIONS } from '../../helpers/adressHelpers/adressStatusLabels.js'
import { statusOptionsFor } from '../../helpers/statusConfig/resolveStatusDisplay'

/**
 * The household status dropdown, shared by the overview table, the address
 * detail page, the task editor and the mobile household page.
 *
 * **Geef `display` mee.** Zonder die prop toont de lijst de standaardwoorden en
 * alle zeven statussen — dat is het gedrag van vóór ADR-032 laag D, en het is
 * bewust de terugval: een gemiste aanroeper laat de instelling links liggen in
 * plaats van de lijst leeg te maken. Er is wél geen enkel signaal dat je hem
 * vergeten bent, dus `AdressStatusSelect.test.jsx` telt de aanroepplekken na.
 * AI-CONTEXT: See docs/pitfalls.md#ui-removed-prop-resurrects-default
 *
 * @param {object} props
 * @param {string} props.value - Current Adresses.Status value
 * @param {(e: React.ChangeEvent<HTMLSelectElement>) => void} props.onChange - Change handler; receives the raw event
 * @param {object} [props.display] - Weergavelaag uit `useStatusDisplays().adress`
 * @param {string} [props.docid] - Written to `data-docid` for handlers that read it off the event
 * @param {string} [props.id] - Adresses.ID, written to `data-id` — de statushistorie logt op ID, niet op docid
 * @param {string} [props.className] - Optional extra class on the <select>
 */
const AdressStatusSelect = ({ value, onChange, display, docid, id, className }) => {
    // De status die er nú op staat gaat als tweede argument mee, zodat een
    // verborgen status blijft renderen op een huishouden dat hem draagt.
    // Zonder dat toont de lijst blanco en schrijft één wijziging een andere
    // status weg dan er stond — ADR-031 regel 4.
    const options = display
        ? statusOptionsFor(display, value)
        : ADRESS_STATUS_OPTIONS

    return (
        <select
            data-docid={docid}
            data-id={id}
            // De status van vóór de wijziging; de handler heeft 'm nodig om de
            // wissel vast te leggen en leest 'm van hetzelfde element af.
            data-status={value || ''}
            value={value || ''}
            onChange={onChange}
            className={className}
        >
            <option value="">-- Selecteer een status --</option>
            {options.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
        </select>
    )
}

export default AdressStatusSelect
